// Application types

const PROFILE = {
  LOADING: "LOADING",
  MY_PROFILE: "MY_PROFILE",
  UPDATING: "UPDATING",
  FILTERING: "FILTERING",
  FILTER_VERIFICATION_LEVEL: "FILTER_VERIFICATION_LEVEL",
  SEARCHING: "SEARCHING",
  SHOW_A_VERIFICATION: "SHOW_A_VERIFICATION",
  SEARCH_VERIFICATION: "SEARCH_VERIFICATION",
};

export default PROFILE;
